export default __webpack_public_path__ + "static/media/les_andelys03.56948a1a.jpg";